import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const BabyBoomerFactsPage: React.FC = () => {
  const { getImage } = useImages();
  const familyImage = getImage('bored-family.-life-saving-alert.jpg');
  const easeWorriesImage = getImage('Ease-Your-Worries.jpg');
  const caringParentsImage = getImage('caring-for-parents-2.jpg');
  const infographicImage = getImage('Alert1-Infographic-Boomers-Turn-65-2-.jpg');

  return (
    <div className="baby-boomer-facts-page">
      {/* Main Content Section */}
      <section style={{ padding: '2rem 1.5rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '2rem', 
            color: '#c8102e',
            lineHeight: '1.2'
          }}>
            Baby Boomers Facts: How Are They Planning for the Future?
          </h1>
          
          <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
            {familyImage && (
              <img 
                src={familyImage} 
                alt="Baby Boomer family watching television" 
                style={{ 
                  maxWidth: '450px',
                  width: '100%',
                  height: 'auto',
                  float: 'right',
                  marginLeft: '2rem',
                  marginBottom: '1rem'
                }}
              />
            )}
            
            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              People say that history repeats itself. Events with similar patterns cycle through world history. However, nobody knows if history will decide to repeat the great Baby Boom. The years after WWII, from 1946 to 1964, are known as the 'Baby Boom' years. The whole nation was eager to settle down and have families after the turmoil of the war. Children born into those families, known as 'Baby Boomers', have now reached retirement age.
            </p>
            
            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              With so many the population reaching 65, we wanted to share some Baby Boomer facts. Alert1 became curious about what they had planned for their retirement. How are Boomers preparing their finances? What kind of lifestyle are they hoping to have after they retire? Are they planning on continuing to live independently?
            </p>
            
            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              We've presented these Baby Boomer facts based on all the data and information we've been able to find. Hopefully, this helps other aging folks know what to expect when they turn 65.
            </p>
          </div>

          {/* Financial Planning Section */}
          <h2 style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            marginBottom: '2rem', 
            color: '#333',
            textAlign: 'center'
          }}>
            Financial Planning
          </h2>

          <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
            {easeWorriesImage && (
              <img 
                src={easeWorriesImage} 
                alt="Senior man smiling" 
                style={{ 
                  maxWidth: '250px',
                  width: '100%',
                  height: 'auto',
                  float: 'right',
                  marginLeft: '2rem',
                  marginBottom: '1rem'
                }}
              />
            )}

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              It's simple Baby Boomer facts that every year brings new challenges for people looking to retire. Having enough money in the bank to support retirement is just one of them.
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              On average, the Baby Boomer generation has saved $38,000 for retirement, not including social security or pensions. Those that have qualified retirement plans averaged $88,000 saved. While this is not much to live off, 48% of Boomers feel comfortable with their savings. The statistics below break down Baby Boomers' true feelings about their savings:
            </p>

            <ul style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.8', 
              color: '#444',
              marginBottom: '1rem',
              marginLeft: '1.5rem'
            }}>
              <li>48% feel comfortable with their savings and are on par with their peers</li>
              <li>20% are ahead of the game and doing better than most</li>
              <li>14% are just getting started</li>
              <li>13% feel behind</li>
              <li>5% are lost and confused</li>
            </ul>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              Recent years have shown that Baby Boomers <a href="https://www.investopedia.com/articles/retirement/08/baby-boomer-retirement.asp" target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc', textDecoration: 'underline' }}>aren't using traditional pensions</a> anymore. As of now, 35% of Baby Boomers are relying on social security income for their retirement. However, this shouldn't be the only method for income in retirement. Too many Baby Boomers are expectant that they will receive enough money to live off from social security.
              {/* TODO(editorial): Verify the 35% Social Security claim against a current authoritative source. */}
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              Looking for some helpful Baby Boomer facts? Boomers can ease the reliance on social security by saving money in different areas. Income can be divided between personal banking accounts, 401K accounts, and social security. The saying "don't put all your eggs in one basket," rings true when it comes to saving for retirement.
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              While retirement accounts, savings, and social security are just a few ways of supporting retirement, Boomers should consider looking into stocks, bonds, and capital as other means to bring in money.
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              With this information, we know that Boomers are going to have to downsize parts of their lifestyles during retirement to stay within their new budget.
            </p>
          </div>

          {/* Lifestyle Planning Section */}
          <h2 style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            marginBottom: '2rem', 
            color: '#333',
            textAlign: 'center'
          }}>
            Lifestyle Planning
          </h2>

          <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
            {caringParentsImage && (
              <img 
                src={caringParentsImage} 
                alt="Multi-generational family" 
                style={{ 
                  maxWidth: '320px',
                  width: '100%',
                  height: 'auto',
                  float: 'right',
                  marginLeft: '2rem',
                  marginBottom: '1rem'
                }}
              />
            )}

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              The American population is living longer and staying active. Baby Boomers are no exception. Their generation is driven and ambitious. Most Boomers don't plan on moving out of their current home when they retire. Most Boomers, 54%, believe they will likely live out their lives in their current home. The statistics below provide some Baby Boomer facts on how this generation plans to spend the rest of their days:
            </p>

            <ul style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.8', 
              color: '#444',
              marginBottom: '1rem',
              marginLeft: '1.5rem'
            }}>
              <li>42% cycle between work & leisure</li>
              <li>17% never work for pay again</li>
              <li>16% work part time</li>
              <li>13% start their own business</li>
              <li>6% work full time</li>
              <li>6% other</li>
            </ul>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              As the Boomers age, they face new health challenges. With the help of their doctors, Boomers are creating health plans that will keep them active into their golden years. Most Boomers believe that an additional support system is a great idea, especially to anticipate emergencies. 79% of Boomers think medical alert systems are a great aid to living on their own. Yet only 13% of Boomers currently have a medical alert system.
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>Medical alert systems</Link> bring great peace of mind to Boomers looking to age in place while enjoying retirement. These systems allow people to stay safe and protected while enjoying their active lifestyle and new freedom.
            </p>

            <p style={{ 
              fontSize: '1.05rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '1rem'
            }}>
              Deciding to retire is never easy. It can take some time getting used to a new lifestyle during the transition process. We at Alert1 will offer whatever support we can. We're here to support the Baby Boomers every step of the way.
            </p>
          </div>

          {/* Infographic Section */}
          {infographicImage && (
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              <img 
                src={infographicImage} 
                alt="Baby Boomers Turn 65 Infographic" 
                style={{ 
                  maxWidth: '100%',
                  width: 'auto',
                  height: 'auto',
                  display: 'inline-block'
                }}
              />
            </div>
          )}

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BabyBoomerFactsPage;
